import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '深圳中锐云官网首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/naShui'
            },
            {
              path: '/software/naShui',
              name: 'software',
              component: resolve => require(['@/view/Software_naShui'], resolve),
              meta: {
                title: '软件产品丨纳税人学堂'
              }
            },
            {
              path: '/software/zhiShui',
              name: 'software',
              component: resolve => require(['@/view/Software_zhiShui'], resolve),
              meta: {
                title: '软件产品丨智税问办一体化平台'
              }
            },
            {
              path: '/software/yeWu',
              name: 'software',
              component: resolve => require(['@/view/Software_yeWu'], resolve),
              meta: {
                title: '软件产品丨业务提升管理平台'
              }
            },
            {
              path: '/software/animation',
              name: 'software',
              component: resolve => require(['@/view/Software_animation'], resolve),
              meta: {
                title: '软件产品丨动画课件制作'
              }
            },
            {
              path: '/software/live',
              name: 'software',
              component: resolve => require(['@/view/Software_live'], resolve),
              meta: {
                title: '软件产品丨精品直播间'
              }
            },
            {
              path: '/software/5gkw',
              name: '5GKW',
              component: resolve => require(['@/view/Software_5gkw'], resolve),
              meta: {
                title: '软件产品丨5G快问'
              }
            },
            {
              path: '/software/meta',
              name: 'meta',
              component: resolve => require(['@/view/Software_meta'], resolve),
              meta: {
                title: '软件产品丨AI数字人'
              }
            }
          ]
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/medialist',
          name: 'mediaList',
          component: resolve => require(['@/view/mediaList'], resolve),
          meta: {
            title: '媒体视点'
          }
        }
        // , {
        //   path: 'nsrxt',
        //   name: 'nsrxt',
        //   component: resolve => require(['@/view/nsrxt'], resolve),
        //   meta: {
        //     title: 'nsrxt'
        //   }
        // }
      ]
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js